import {
	GuestVisitStatusTypeArray,
	GuestVisitStatusTypeLabel,
	GuestVisitType,
} from '@kinderlabs-pos/shared-data-type';
import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { FilterWith전체Selector } from '../../composites/FilterWithAllSelector';

export type GuestVisitFilterType = {
	status?: GuestVisitType['status'];
};
export interface IGuestVisitFilterDialogProps extends XlDialogProps {
	filter: GuestVisitFilterType;
	setFilter: React.Dispatch<React.SetStateAction<GuestVisitFilterType>>;
}
export const GuestVisitFilterDialog: React.FC<IGuestVisitFilterDialogProps> = ({
	open,
	closeDialog,
	filter,
	setFilter,
}) => {
	const [tempFilter, setTempFilter] = React.useState(filter);

	return (
		<WithDialog.XlDialog
			scroll='paper'
			open={open}
			closeDialog={closeDialog}>
			<DialogTitle>고객 필터</DialogTitle>
			<DialogContent>
				<Stack
					direction={'row'}
					spacing={1}
					py={1}>
					<Box width={180}>
						<FilterWith전체Selector
							label={'주문 상태'}
							candidates={GuestVisitStatusTypeArray.map((status) => ({
								label: GuestVisitStatusTypeLabel[status],
								value: status,
							}))}
							value={tempFilter.status}
							onChangeValue={(value) => {
								// @ts-ignore // 아 select 들 type 짜증나...
								setTempFilter((prev) => ({ ...prev, status: value }));
							}}
						/>
					</Box>
					{/* <Box width={180} my={1}>

          </Box> */}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button
					variant={'contained'}
					onClick={() => {
						setFilter(tempFilter);
						closeDialog && closeDialog();
					}}>
					확인
				</Button>
				<Button
					onClick={closeDialog}
					variant={'outlined'}>
					취소
				</Button>
			</DialogActions>
		</WithDialog.XlDialog>
	);
};
